// TODO: Refactor to maybe use different stacks, which you can choose from on instance creation
import { createContext, useContext, useState, ReactNode, useMemo, ReactElement } from 'react';

type Screen =
  | { name: 'categories' }
  | {
      name: 'category';
      params: {
        id: string;
      };
    }
  | {
      name: 'folder';
      params: {
        id: string;
      };
    }
  | {
      name: 'article';
      params: {
        id: string;
      };
    }
  | {
      name: 'medication';
      params: {
        id: string;
      };
    }
  | { name: 'search' };

type ModalNavigationContextValue = {
  screen: Screen;
  navigate: (screen: Screen) => void;
  goBack: () => void;
};

const ModalNavigationContext = createContext<ModalNavigationContextValue | undefined>(undefined);

const INITIAL_SCREEN: Screen = { name: 'categories' };

type ModalNavigationProviderProps = {
  children: ReactNode;
};

export const ModalNavigationProvider = ({
  children,
}: ModalNavigationProviderProps): ReactElement => {
  const [history, setHistory] = useState<Screen[]>([INITIAL_SCREEN]);

  const navigate = (screen: Screen): void => {
    setHistory((prev) => [...prev, screen]);
  };

  const goBack = (): void => {
    setHistory((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
  };

  const screen = history[history.length - 1];

  const value = useMemo(() => ({ screen, navigate, goBack }), [screen]);

  return (
    <ModalNavigationContext.Provider value={value}>{children}</ModalNavigationContext.Provider>
  );
};

export const useModalNavigation = (): ModalNavigationContextValue | undefined => {
  const context = useContext(ModalNavigationContext);
  //   if (!context) throw new Error('useModalNavigation must be used within ModalNavigationProvider');
  return context;
};

export const useIsInModal = (): boolean => {
  try {
    const context = useContext(ModalNavigationContext);
    return !!context;
  } catch (error) {
    return false;
  }
};
